module.exports = __webpack_public_path__ + "img/pluto34.5dbe3508.jpg";